// skeleton/app/src/app/shared/components/menu-navbar/menu-navbar.component.ts

import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseHttpService } from '../../../shared/services/basehttp.service';
import { Constants } from '../../../shared/constants';
import { UserServiceService } from '../../../user/survey-main/service/user-service.service';
import { UserGroupModel } from '../../../admin/models/group.model';
import { AppGlobals } from '../../../app.global';
import { ParamService } from '../../../shared/services/param.service';
import { LogoutServive } from '../../../logout/logout.service';
import { MenubarService } from '../../../shared/services/menunavbar.services';
import * as roleConfiguration from 'src/app/configuration/roleconfiguration';
import { environment } from 'src/environments/environment';
import { StorageService } from '../../services/token-storage.service';
import { SiteminderAuthService } from 'src/app/auth/oidc-config.service';

@Component({
  selector: 'app-menu-navbar',
  templateUrl: './menu-navbar.component.html',
  styleUrls: ['./menu-navbar.component.scss'],
  providers: [AppGlobals],
  standalone: false,
})
export class MenuNavbarComponent
  implements OnInit, OnDestroy
{
  private readonly destroy$ =
    new Subject<void>();

  constants: Constants =
    new Constants();

  user: UserGroupModel;

  isAdmin: boolean = false;
  isRespondent: boolean = false;
  isDesigner: boolean = false;

  userTypeID = 0;
  UserLoggedIn: boolean = false;

  isExist = false;
  filteredMenulist: any;

  clickFlag: boolean = false;

  isBPDashboard: boolean = false;
  isIncidentReport: boolean = false;
  isBpAnalytics: boolean = false;

  isEntityDashboard: boolean = false;
  isManageOrg: boolean = false;
  isMangeValidation: boolean = false;
  isMappingEntity: boolean = false;
  isViewreport: boolean = false;

  bpSubMenu: boolean = false;
  adminSubMenu: boolean = false;
  entitySubMenu: boolean = false;
  isDashboardTableau: boolean = false;

  scrHeight: any;
  scrWidth: any;

  localStoUrl: string = '';

  @HostListener(
    'window:resize',
    ['$event']
  )
  getScreenSize(
    event?: any
  ): void {
    try {
      this.scrHeight =
        window.innerHeight;

      this.scrWidth =
        window.innerWidth;
    } catch (error) {
      this.logError(
        'Screen size update failed',
        error
      );
    }
  }

  constructor(
    private baseHttpService: BaseHttpService,
    private userService: UserServiceService,
    private router: Router,
    private _global: AppGlobals,
    private paramservice: ParamService,
    private logoutservice: LogoutServive,
    private activatedroute: ActivatedRoute,
    private menubarService: MenubarService,
    private changeDetector: ChangeDetectorRef,
    private siteminderAuthService: SiteminderAuthService,
    private storage: StorageService
  ) {
    this.getScreenSize();
  }

  ngOnInit(): void {
    try {
      this.Getaccess();

      this.menubarService.data
        .pipe(
          takeUntil(
            this.destroy$
          )
        )
        .subscribe({
          next: (result) => {
            try {
              this.isExist =
                result;
            } catch (error) {
              this.logError(
                'Menu state processing failed',
                error
              );
            }
          },
          error: (error) => {
            this.logError(
              'Menu state subscription failed',
              error
            );
          },
        });
    } catch (error) {
      this.logError(
        'Menu initialization failed',
        error
      );
    }
  }

  ngAfterContentChecked(): void {
    try {
      this.changeDetector.detectChanges();
    } catch (error) {
      this.logError(
        'Menu change detection failed',
        error
      );
    }
  }

  ngOnDestroy(): void {
    try {
      this.destroy$.next();
      this.destroy$.complete();
    } catch (error) {
      this.logError(
        'Menu cleanup failed',
        error
      );
    }
  }

  Getaccess(): void {
    try {
      this.userService.currentUser
        .pipe(
          takeUntil(
            this.destroy$
          )
        )
        .subscribe({
          next: (
            result: UserGroupModel
          ) => {
            try {
              if (
                !result ||
                Object.keys(
                  result
                ).length === 0
              ) {
                const userData:
                  UserGroupModel =
                  new UserGroupModel();

                userData.userId =
                  this.storage.get(
                    'LoggedInuserId'
                  );

                userData.email =
                  this.storage.get(
                    'LoggedInuserMailId'
                  );

                userData.userTypeId =
                  this.storage.get(
                    'LoggedInUserTypeId'
                  );

                userData.userTypeDesc =
                  this.storage.get(
                    'LoggedInUserTypeDesc'
                  );

                if (
                  userData.userId !=
                  null
                ) {
                  result =
                    userData;
                }
              }

              if (
                result != null &&
                Object.keys(
                  result
                ).length !== 0
              ) {
                this.user =
                  result;

                let isSiteminderValid =
                  false;

                try {
                  isSiteminderValid =
                    this.siteminderAuthService.isTokenValid();
                } catch (error) {
                  this.logError(
                    'SiteMinder token validation failed',
                    error
                  );

                  isSiteminderValid =
                    false;
                }

                if (
                  this.user
                    .userTypeId !=
                    null &&
                  this.user
                    .userTypeId !=
                    '' &&
                  isSiteminderValid
                ) {
                  this.isExist =
                    true;

                  const addmenuList =
                    roleConfiguration.AdminMenuList;

                  const usertypeid =
                    this.user
                      .userTypeId;

                  this.filteredMenulist =
                    addmenuList.filter(
                      (p) =>
                        p.roleid ==
                        usertypeid
                    );

                  this.filteredMenulist =
                    this.filteredMenulist.filter(
                      (
                        item,
                        i,
                        ar
                      ) =>
                        ar.indexOf(
                          item
                        ) === i
                    );

                  this.filteredMenulist.sort(
                    (a, b) =>
                      a.sequence >
                      b.sequence
                        ? 1
                        : -1
                  );

                  this.menubarService.tempholdMenuData(
                    this.filteredMenulist
                  );

                  this.filteredMenulist.forEach(
                    (element) => {
                      element.isSelected =
                        false;
                    }
                  );

                  const storedMenuUrl =
                    this.storage.get(
                      'CurrentMeuItemUrl'
                    );

                  if (
                    storedMenuUrl
                  ) {
                    try {
                      this.localStoUrl =
                        JSON.parse(
                          storedMenuUrl
                        );
                    } catch (error) {
                      this.logError(
                        'Menu state restore failed',
                        error
                      );

                      this.localStoUrl =
                        '';
                    }

                    if (
                      this.localStoUrl !=
                        null &&
                      (this.user
                        .userTypeDesc ===
                        'Respondent' ||
                        this.user
                          .userTypeDesc ===
                          'Survey Admin')
                    ) {
                      const surveyTab =
                        this.filteredMenulist[
                          0
                        ];

                      if (
                        surveyTab
                      ) {
                        surveyTab.isSelected =
                          true;

                        this.storage.set(
                          'CurrentMeuItemUrl',
                          JSON.stringify(
                            '/businessprocess'
                          )
                        );
                      }
                    } else {
                      const prevTab =
                        this.filteredMenulist.filter(
                          (x) =>
                            x.navigateUrl ==
                            this
                              .localStoUrl
                        )[0];

                      if (
                        prevTab
                      ) {
                        prevTab.isSelected =
                          true;

                        this.storage.set(
                          'CurrentMeuItemUrl',
                          JSON.stringify(
                            prevTab.navigateUrl
                          )
                        );
                      }
                    }
                  } else {
                    this.localStoUrl =
                      '';

                    if (
                      this.user
                        .userTypeDesc ===
                        'Respondent' ||
                      this.user
                        .userTypeDesc ===
                        'Survey Admin'
                    ) {
                      const surveyTab =
                        this.filteredMenulist[
                          0
                        ];

                      if (
                        surveyTab
                      ) {
                        surveyTab.isSelected =
                          true;

                        this.storage.set(
                          'CurrentMeuItemUrl',
                          JSON.stringify(
                            '/businessprocess'
                          )
                        );
                      }
                    } else {
                      const surveyTab =
                        this.filteredMenulist.filter(
                          (x) =>
                            x.tab ===
                            'Dashboard summary'
                        )[0];

                      if (
                        surveyTab !=
                        null
                      ) {
                        surveyTab.isSelected =
                          true;

                        this.storage.set(
                          'CurrentMeuItemUrl',
                          JSON.stringify(
                            surveyTab.navigateUrl
                          )
                        );
                      }
                    }
                  }
                } else {
                  this.isExist =
                    false;

                  this.menubarService.tempholdMenuData(
                    []
                  );
                }
              } else {
                this.isExist =
                  false;

                this.menubarService.tempholdMenuData(
                  []
                );
              }
            } catch (error) {
              this.isExist =
                false;

              try {
                this.menubarService.tempholdMenuData(
                  []
                );
              } catch (
                menuError
              ) {
                this.logError(
                  'Menu reset failed',
                  menuError
                );
              }

              this.logError(
                'Menu access processing failed',
                error
              );
            }
          },
          error: (error) => {
            this.isExist =
              false;

            this.logError(
              'User state subscription failed',
              error
            );
          },
        });
    } catch (error) {
      this.isExist = false;

      this.logError(
        'Menu access setup failed',
        error
      );
    }
  }

  onClickofMenuItem(
    event: any,
    index: number,
    subItem?: string
  ): void {
    try {
      this.clickFlag = false;
      this.isBPDashboard =
        false;
      this.isIncidentReport =
        false;
      this.isBpAnalytics =
        false;

      this.bpSubMenu = false;
      this.adminSubMenu =
        false;
      this.entitySubMenu =
        false;

      if (
        !this.filteredMenulist ||
        !this.filteredMenulist[
          index
        ]
      ) {
        return;
      }

      this.filteredMenulist.forEach(
        (element) => {
          element.isSelected =
            false;
        }
      );

      this.storage.remove(
        'selectedOrgInPanel'
      );

      this.storage.remove(
        'selectedGroupInPanel'
      );

      if (
        this.filteredMenulist[
          index
        ].tab ===
        'Business process'
      ) {
        this.clickFlag = true;
        this.isBPDashboard =
          true;

        if (
          subItem ===
          'isBPDashboard'
        ) {
          this.isIncidentReport =
            false;

          this.isBPDashboard =
            true;

          this.isBpAnalytics =
            false;
        } else if (
          subItem ===
          'isIncidentReport'
        ) {
          this.isBPDashboard =
            false;

          this.isIncidentReport =
            true;

          this.isBpAnalytics =
            false;
        } else if (
          subItem ===
          'isBpAnalytics'
        ) {
          this.isBPDashboard =
            false;

          this.isIncidentReport =
            false;

          this.isBpAnalytics =
            true;
        }
      }

      if (
        this.filteredMenulist[
          index
        ].tab === 'Admin'
      ) {
        this.isManageOrg =
          true;

        if (
          subItem ===
          'isManageOrg'
        ) {
          this.isMangeValidation =
            false;

          this.isManageOrg =
            true;

          this.isViewreport =
            false;

          this.isDashboardTableau =
            false;
        } else if (
          subItem ===
          'isManageValidation'
        ) {
          this.isManageOrg =
            false;

          this.isMangeValidation =
            true;

          this.isViewreport =
            false;

          this.isDashboardTableau =
            false;
        } else if (
          subItem ===
          'isViewreport'
        ) {
          this.isMangeValidation =
            false;

          this.isManageOrg =
            false;

          this.isViewreport =
            true;

          this.isDashboardTableau =
            false;
        } else if (
          subItem ===
          'isDashboardTableau'
        ) {
          this.isMangeValidation =
            false;

          this.isManageOrg =
            false;

          this.isViewreport =
            false;

          this.isDashboardTableau =
            true;
        }
      }

      if (
        this.filteredMenulist[
          index
        ].tab === 'Entity'
      ) {
        this.isEntityDashboard =
          true;

        if (
          subItem ===
          'isEntityDashboard'
        ) {
          this.isMappingEntity =
            false;

          this.isEntityDashboard =
            true;
        } else if (
          subItem ===
          'isMappingEntity'
        ) {
          this.isEntityDashboard =
            false;

          this.isMappingEntity =
            true;
        }
      }

      this.filteredMenulist[
        index
      ].isSelected = true;

      this.storage.set(
        'CurrentMeuItemUrl',
        JSON.stringify(
          this.filteredMenulist[
            index
          ].navigateUrl
        )
      );
    } catch (error) {
      this.logError(
        'Menu item selection failed',
        error
      );
    }
  }

  setBpSubMenuFlag(
    event: any
  ): void {
    try {
      this.bpSubMenu = true;
    } catch (error) {
      this.logError(
        'Business process menu update failed',
        error
      );
    }
  }

  @HostListener(
    'click',
    ['$event']
  )
  onClick(
    e: MouseEvent
  ): void {
    try {
      this.bpSubMenu = false;
      this.adminSubMenu =
        false;
      this.entitySubMenu =
        false;
    } catch (error) {
      this.logError(
        'Menu close failed',
        error
      );
    }
  }

  setAdminSubMenuFlag(
    event: any
  ): void {
    try {
      this.adminSubMenu =
        true;
    } catch (error) {
      this.logError(
        'Admin menu update failed',
        error
      );
    }
  }

  setEntitySubMenuFlag(
    event: any
  ): void {
    try {
      this.entitySubMenu =
        true;
    } catch (error) {
      this.logError(
        'Entity menu update failed',
        error
      );
    }
  }

  tableauDashboardMenuItemClick():
    void {
    try {
      const url =
        environment.tableauUrl;

      window.open(
        url,
        '_blank'
      );
    } catch (error) {
      this.logError(
        'Tableau dashboard open failed',
        error
      );
    }
  }

  private logError(
    context: string,
    error: unknown
  ): void {
    try {
      const messages:
        string[] = [];

      let currentError:
        unknown = error;

      let depth = 0;

      while (
        currentError &&
        depth < 5
      ) {
        if (
          currentError instanceof
          Error
        ) {
          messages.push(
            currentError.message ||
              currentError.name
          );

          const nestedError =
            currentError as Error & {
              cause?: unknown;
              innerException?: unknown;
              innerError?: unknown;
            };

          currentError =
            nestedError.cause ??
            nestedError.innerException ??
            nestedError.innerError ??
            null;
        } else if (
          typeof currentError ===
            'object' &&
          currentError !== null &&
          'message' in
            currentError &&
          typeof (
            currentError as {
              message?: unknown;
            }
          ).message ===
            'string'
        ) {
          messages.push(
            (
              currentError as {
                message: string;
              }
            ).message
          );

          currentError = null;
        } else {
          messages.push(
            'Unknown error'
          );

          currentError = null;
        }

        depth++;
      }

      console.error(
        `${context}${
          messages.length
            ? `: ${messages.join(
                ' | '
              )}`
            : ''
        }`
      );
    } catch {
      console.error(
        context
      );
    }
  }
}